<template>
    <main class="c-app-content is-sidebar-tiny">
        <g-loading v-if="firstLoading" />
        <g-table v-else :filter="filterFormModel" :itemCount="itemCount" :items="items" :fields="fields" :isSearch='false' @load="load" @reset="reset"
                 title="Đơn vị" titleIcon="fa fa-cubes">
            <template slot="filter">
            </template>
            <template #cell(name)="{item}">
                <span :class="(item.blocked ? 'c-signal' : 'c-signal is-success')"><span class="h-word-break">{{item.name}}</span></span>
            </template>
            <template #cell(address)="{item}">
                <div v-if='item.ward_id' >
                    <span v-if='params.ward[item.ward_id]'>{{ item.address }}, {{params.ward[item.ward_id].name}}</span> 
                </div>
                <span></span>
            </template>
            <template #cell(info)="{item}">
                <div v-if="item.phone"><span class="small text-gray-999">Điện thoại: </span>{{ item.phone }}</div>
                <div v-if="item.fax"><span class="small text-gray-999">Fax: </span>{{ item.fax }}</div>
                <div v-if="item.email"><span class="small text-gray-999">Email: </span>{{ item.email }}</div>
            </template>
            <template #cell(waste)="{item}">
                <div ><span class="small text-gray-999">Lưu lượng nước thải (m3/ngày đêm): </span>{{ item.wastewater }}</div>
                <div ><span class="small text-gray-999">Lưu lượng khí thải (m3/ngày đêm): </span>{{ item.emissions }}</div>
                <div ><span class="small text-gray-999">Lưu lượng rác thải (kg/ngày đêm): </span>{{ item.waste }}</div>
            </template>
            <template slot="action">
                <g-button :loading="saveLoading" v-if="permissions('environment-client_create')"  size="sm" variant="success" icon="fa fa-plus" content="Thêm mới"  @click="create" />
            </template>
            <template #cell(action)="{item}">
                <g-button v-if="permissions('environment-client_update')"  :loading="updateLoading" size="sm" variant="outline-info" class="ml-1 mb-1" icon="pencil" @click="update(item.id)"  />
                <g-button v-if="permissions('environment-client_del')"  :loading="delLoading" size="sm" variant="outline-danger" class="ml-1 mb-1"   icon="trash-fill" @click='del(item.id)' />
            </template>
        </g-table>
        <b-modal v-model="showForm" size="xl" :title="formTitle" @ok="save" no-close-on-backdrop no-enforce-focus>
            <div class="row">
                <div class="col-md-6">
                    <label>Thông tin chung</label>
                    <form-input label="Tên đơn vị" :required='true' :model="formModel" attribute="name" :errors="formErrors"/>
                    <form-input label="Chủ đơn vị" :required='true' :model="formModel" attribute="owner" :errors="formErrors"/>
                    <form-input label="Địa chỉ" :required='true' :model="formModel" attribute="address" :errors="formErrors"/>
                    <ward-select label="Phường/Xã"  :required='true'  :model="formModel" attribute="ward_id" :multiple="false" :errors="formErrors" :close-on-select='true' :filter="{did: 509}" />
                    <div class="row">
                        <div class="col-md-6">
                        <form-input label="Điện thoại" :required='false' :model="formModel" attribute="phone" :errors="formErrors" />
                        </div>
                        <div class="col-md-6">
                            <form-input label="Fax" :required='false' :model="formModel" attribute="fax" :errors="formErrors"/>
                        </div>
                    </div>
                    <form-input label="Email" :required='false' :model="formModel" attribute="email" :errors="formErrors"/>
                </div>
                <div class="col-md-6">
                    <label>Thông tin nguồn thải</label>
                    <form-input label="Lưu lượng nước thải (m3/ngày đêm)" :required='false' :model="formModel" attribute="wastewater" :errors="formErrors"/>
                    <form-input label="Lưu lượng khí thải (m3/ngày đêm)" :required='false' :model="formModel" attribute="emissions" :errors="formErrors"/>
                    <form-input label="Lưu lượng rác thải (kg/ngày đêm)" :required='false' :model="formModel" attribute="waste" :errors="formErrors"/>
                    <form-checkbox chk-label="Tạm ẩn trên website" :model="formModel" :errors="formErrors"  attribute="blocked" />
                </div>
            </div>
            

            <template v-slot:modal-footer="{ ok, cancel}">
                <b-button variant="secondary" class="float-right" @click="cancel">Đóng</b-button>
                <b-button :disabled="saveLoading" variant="primary" class="float-right" @click="ok">
                    <b-spinner v-if="saveLoading" small></b-spinner>
                    <em v-else class="fa fa-save" ></em>
                    Lưu lại
                </b-button>
            </template>
        </b-modal>
    </main>
</template>

<script>
    import list from "@/mixins/List";
    import crud from '@/mixins/CRUD';
    import role from '@/mixins/Role';
    import WardSelect from '@/components/WardSelect';

    export default {
        components: {WardSelect},
        mixins: [list, crud, role],
        data: function () {
            return {
                reloadBus: "reloadEnvironmentClient",
                service: '/environment-client',
                fields: [
                    {key: 'name', label: "Tên thẻ", class: 'text-left'},
                    {key: 'address', label: "Địa chỉ", class: 'text-left'},
                    {key: 'info', label: "Thông tin khác", class: 'text-left'},
                    {key: 'waste', label: "Thông tin nguồn thải", class: 'text-left'},
                    {key: 'action', label: "Hành động", class: 'text-right'},
                ],
                defaultFilterFormModel: {
                    keyword: '',
                },
                defaultFormModel: {
                    blocked: 0,
                },
            }
        },
        methods: {
            search(val) {
                this.filterFormModel.type = val;
                this.load();
            },
            reset() {
                this.filterFormModel.keyword = '';
                this.$router.go(this.$router.currentRoute)
            },
        },
        mounted() {
        }
    }
</script>